import React, { useState } from "react";
import Button from "../../components/Button";
import { useNavigate } from "react-router";

export default function TokenLoginPage() {
  const [loading, setLoading] = useState(false);
  const [eCommId, setECommId] = useState("");
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  async function authorizeSession() {
    setLoading(true);
    const response = await fetch(
      `${
        import.meta.env.VITE_API_URL
      }/integration/auth/authorize?scope=integration.session.token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${btoa(
            import.meta.env.VITE_USER_NAME +
              ":" +
              import.meta.env.VITE_USER_PASS
          )}`,
        },
      }
    );
    const result = await response.json();
    if (result.status.success) {
      getToken(result.data.token.uuid);
    } else {
      setError(true);
    }
  }

  async function getToken(fromBasic) {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/integration/session/token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${fromBasic}`,
          touchpoint: "discoverglode",
        },
        body: JSON.stringify({
          consumer: {
            sfId: eCommId,
          },
          session: {
            ip: "127.0.0.1",
            token: "discoverglode",
            expires: "2030-01-01T00:00:00+0200",
          },
        }),
      }
    );
    const result = await response.json();
    if (result.status.success) {
      localStorage.setItem("token", result.data.token.uuid);
      setTimeout(() => { navigate("/") }, 300)
    } else {
      setError(true);
    }
  }

  return (
    <section className="token-page">
      {!loading ? (
        <form onSubmit={authorizeSession} method="POST">
          <label htmlFor="eCommId">
            <h1>Enter eCommId</h1>
          </label>
          <input
            type="text"
            value={eCommId}
            onChange={(e) => setECommId(e.target.value)}
            placeholder={"eCommId"}
            id="eCommId"
            required
          />
          <Button submit>Login</Button>
        </form>
      ) : error ? (
        <>
          <h1>Error</h1>
          <Button
            action={() => {
              setError(false);
              setECommId("");
              setLoading(false);
            }}
          >
            Go back
          </Button>
        </>
      ) : (
        <h1>Refreshing token...</h1>
      )}
    </section>
  );
}